import { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import {
  CasBaseDialog,
  CasButton,
  CasDisplayField,
  CasRenderDate,
  CasTable,
  CasToolbar,
} from 'src/compass/shared/components';

import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';
import useExportExcelMutation from 'src/compass/shared/hooks/reactQuery/useExportExcelMutation';
import useCasBoolean from 'src/compass/shared/hooks/useCasBoolean';
import ClaimDetailsDialog from './ClaimDetailsDialog';
import BatchHistoryDialog from './BatchHistoryDialog';

interface UnbatchedAttachedDialogProps {
  onClose: VoidFunction;
}

export default function UnbatchedAttachedDialog({ onClose }: UnbatchedAttachedDialogProps) {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userName = activeAccount?.name?.split(' ')[0] ?? '';

  const historyDialog = useCasBoolean();

  const [dialogRowId, setDialogRowId] = useState<any>(null);
  const [reloadTable, setReloadTable] = useState<Date | null>(null);
  const [data, setData] = useState<any>(null);

  const { mutate } = useExportExcelMutation({
    entity: 'Sce/Claims/AttachBatch/PendingCreateBatch',
    onSuccess: () => setReloadTable(new Date()),
  });

  return (
    <CasBaseDialog open maxWidth="xl" onClose={onClose} title="Unbatched Attached" showCloseIcon>
      <CasToolbar
        left={<CasDisplayField label="User" value={userName} />}
        right={
          <>
            <CasButton variant="text" onClick={historyDialog.setTrue}>
              History
            </CasButton>
            <CasButton variant="outlined" onClick={() => mutate()} disabled={!data?.totalCount}>
              Create Batch
            </CasButton>
          </>
        }
      />

      <CasTable
        entity="Sce/Claims/AttachBatch/Pending"
        update={reloadTable}
        setData={setData}
        columnsSortable={false}
        includeExport={false}
        columns={[
          { field: 'attached', render: CasRenderDate },
          {
            field: 'insuredName',
            render: ({ row }: ICasRenderCellProps) => (
              <CasLink onClick={() => setDialogRowId(row.endorsementId)}>
                {row.insuredName}
              </CasLink>
            ),
          },
          { field: 'reinsuranceYear' },
          { field: 'policyNumber', label: 'Policy#' },
          { field: 'sce' },
        ]}
      />

      {dialogRowId && (
        <ClaimDetailsDialog
          id={dialogRowId}
          onClose={() => {
            setDialogRowId(null);
            setReloadTable(new Date());
          }}
        />
      )}

      {historyDialog.value && (
        <BatchHistoryDialog onClose={historyDialog.setFalse} userName={userName} />
      )}
    </CasBaseDialog>
  );
}
